export default __webpack_public_path__ + "04a84c3c50fc6bb26dea412c1b347ac1.png";